export default __webpack_public_path__ + "58b5ff6693cda8e80f372b95efe33bda.jpg";